import { call, put, takeLatest } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import * as types from '../../../actions/index.types'
import * as req from '../../../../axios/request/SocietyPortal/CreditDebitNoteReqs/CreditDebitNoteReqs'

function* getCreditDebitNotes(action) {
    try {
        const result = yield call(req.getCreditDebitNotesReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_CREDIT_DEBIT_NOTES_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_CREDIT_DEBIT_NOTES_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch notes")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_CREDIT_DEBIT_NOTES_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getCreditDebitNoteDetails(action) {
    try {
        const result = yield call(req.getCreditDebitNoteDetailsReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_CREDIT_DEBIT_NOTE_DETAILS_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_CREDIT_DEBIT_NOTE_DETAILS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch note details")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_CREDIT_DEBIT_NOTE_DETAILS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getCreditDebitNotesByInvoice(action) {
    try {
        const result = yield call(req.getCreditDebitNotesByInvoiceReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_CREDIT_DEBIT_NOTES_BY_INVOICE_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_CREDIT_DEBIT_NOTES_BY_INVOICE_FAILURE, message: result?.message })
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_CREDIT_DEBIT_NOTES_BY_INVOICE_FAILURE, message: e?.message })
    }
}

function* createCreditDebitNote(action) {
    try {
        const result = yield call(req.createCreditDebitNoteReq, action)
        if (result.success === true) {
            toast.success(result.message || "Note created successfully")
            yield put({ type: types.CREATE_CREDIT_DEBIT_NOTE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.CREATE_CREDIT_DEBIT_NOTE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to create note")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CREATE_CREDIT_DEBIT_NOTE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* updateCreditDebitNote(action) {
    try {
        const result = yield call(req.updateCreditDebitNoteReq, action)
        if (result.success === true) {
            toast.success(result.message || "Note updated successfully")
            yield put({ type: types.UPDATE_CREDIT_DEBIT_NOTE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.UPDATE_CREDIT_DEBIT_NOTE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to update note")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_CREDIT_DEBIT_NOTE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* postCreditDebitNote(action) {
    try {
        const result = yield call(req.postCreditDebitNoteReq, action)
        if (result.success === true) {
            toast.success(result.message || "Note posted successfully")
            yield put({ type: types.POST_CREDIT_DEBIT_NOTE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.POST_CREDIT_DEBIT_NOTE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to post note")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.POST_CREDIT_DEBIT_NOTE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* voidCreditDebitNote(action) {
    try {
        const result = yield call(req.voidCreditDebitNoteReq, action)
        if (result.success === true) {
            toast.success(result.message || "Note voided successfully")
            yield put({ type: types.VOID_CREDIT_DEBIT_NOTE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.VOID_CREDIT_DEBIT_NOTE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to void note")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.VOID_CREDIT_DEBIT_NOTE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* deleteCreditDebitNote(action) {
    try {
        const result = yield call(req.deleteCreditDebitNoteReq, action)
        if (result.success === true) {
            toast.success(result.message || "Note deleted successfully")
            yield put({ type: types.DELETE_CREDIT_DEBIT_NOTE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.DELETE_CREDIT_DEBIT_NOTE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to delete note")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.DELETE_CREDIT_DEBIT_NOTE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* bulkUploadCreditDebitNotes(action) {
    try {
        const result = yield call(req.bulkUploadCreditDebitNotesReq, action)
        if (result.success === true) {
            yield put({ type: types.BULK_UPLOAD_CREDIT_DEBIT_NOTES_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
            const failed = result.data?.failed || [];
            if (failed.length === 0) {
                toast.success(result.message || "Notes uploaded successfully")
            } else {
                toast.warn(result.message || "Upload completed with some errors")
            }
        } else {
            yield put({ type: types.BULK_UPLOAD_CREDIT_DEBIT_NOTES_FAILURE, message: result?.message })
            toast.error(result?.message || "Bulk upload failed")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_UPLOAD_CREDIT_DEBIT_NOTES_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* bulkGetCreditDebitNoteDetails(action) {
    try {
        const result = yield call(req.bulkGetCreditDebitNoteDetailsReq, action)
        if (result.success === true) {
            yield put({ type: types.BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_SUCCESS, payload: result })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch note details")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* bulkPostCreditDebitNotes(action) {
    try {
        const result = yield call(req.bulkPostCreditDebitNotesReq, action)
        if (result.success === true) {
            toast.success(result.message || "Notes posted successfully")
            yield put({ type: types.BULK_POST_CREDIT_DEBIT_NOTES_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_POST_CREDIT_DEBIT_NOTES_FAILURE, message: result?.message })
            toast.error(result?.message || "Bulk post failed")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_POST_CREDIT_DEBIT_NOTES_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* bulkDeleteCreditDebitNotes(action) {
    try {
        const result = yield call(req.bulkDeleteCreditDebitNotesReq, action)
        if (result.success === true) {
            toast.success(result.message || "Notes deleted successfully")
            yield put({ type: types.BULK_DELETE_CREDIT_DEBIT_NOTES_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_DELETE_CREDIT_DEBIT_NOTES_FAILURE, message: result?.message })
            toast.error(result?.message || "Bulk delete failed")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_DELETE_CREDIT_DEBIT_NOTES_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

export default function* CreditDebitNoteSaga() {
    yield takeLatest(types.GET_CREDIT_DEBIT_NOTES, getCreditDebitNotes)
    yield takeLatest(types.GET_CREDIT_DEBIT_NOTE_DETAILS, getCreditDebitNoteDetails)
    yield takeLatest(types.GET_CREDIT_DEBIT_NOTES_BY_INVOICE, getCreditDebitNotesByInvoice)
    yield takeLatest(types.CREATE_CREDIT_DEBIT_NOTE, createCreditDebitNote)
    yield takeLatest(types.UPDATE_CREDIT_DEBIT_NOTE, updateCreditDebitNote)
    yield takeLatest(types.POST_CREDIT_DEBIT_NOTE, postCreditDebitNote)
    yield takeLatest(types.VOID_CREDIT_DEBIT_NOTE, voidCreditDebitNote)
    yield takeLatest(types.DELETE_CREDIT_DEBIT_NOTE, deleteCreditDebitNote)
    yield takeLatest(types.BULK_UPLOAD_CREDIT_DEBIT_NOTES, bulkUploadCreditDebitNotes)
    yield takeLatest(types.BULK_GET_CREDIT_DEBIT_NOTE_DETAILS, bulkGetCreditDebitNoteDetails)
    yield takeLatest(types.BULK_POST_CREDIT_DEBIT_NOTES, bulkPostCreditDebitNotes)
    yield takeLatest(types.BULK_DELETE_CREDIT_DEBIT_NOTES, bulkDeleteCreditDebitNotes)
}
